import React, { useContext } from 'react'

import { InfoCircleOutlined } from '@ant-design/icons'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import { PromptEditorTreatment } from '../types'
import { useDebouncer } from '@pushly/aqe/lib/hooks'
import { DEFAULT_INPUT_FIELD_DEBOUNCE_MS, VARIANT_NAME_MAX_CHARS } from '../constants'
import { PromptEditorDispatchContext } from '../reducer'
import { PromptEditorContext } from '../context'
import { Flex, Form, Input, Popover, Row, Space, Typography, Col } from 'antd'

export const PromptAbVariantDetails = () => {
    const dispatch = useContext(PromptEditorDispatchContext)
    const { loading, selectedPrompt, selectedPromptIdx } = useContext(PromptEditorContext)

    const [debounce] = useDebouncer(DEFAULT_INPUT_FIELD_DEBOUNCE_MS)

    const setVariant = (setter: (update: PromptEditorTreatment) => PromptEditorTreatment) => {
        if (loading) return
        dispatch({ type: 'set-prompt', idx: selectedPromptIdx, prompt: setter(selectedPrompt.clone()) })
    }

    return (
        <Well hideHeader={true} hideFooter={true} mode="ghost" flush>
            <Flex gap={8} align="center" justify="stretch">
                <Form.Item layout="vertical" label="Variant Name" style={{ width: '75%' }}>
                    {!loading && (
                        <Input
                            key={selectedPromptIdx}
                            placeholder="Prompt Variant Name"
                            maxLength={VARIANT_NAME_MAX_CHARS}
                            defaultValue={selectedPrompt.name ?? undefined}
                            onChange={(ev) => {
                                debounce(() =>
                                    setVariant((update) => {
                                        update.name = ev.target.value
                                        return update
                                    }),
                                )
                            }}
                        />
                    )}
                </Form.Item>

                <Form.Item
                    style={{ width: '25%' }}
                    layout="vertical"
                    label={
                        <Popover
                            classNames={{ content: 'prompt-display-weight-info-popover' }}
                            content={
                                <Typography.Paragraph>
                                    Display weight determines the percent of site visitors that will see the currently
                                    selected prompt test. The display weight must add up to 100% across all tests.
                                </Typography.Paragraph>
                            }
                        >
                            <span>
                                Display Weight <InfoCircleOutlined className="info-icon" />
                            </span>
                        </Popover>
                    }
                >
                    {!loading && (
                        <Space.Compact block>
                            <Input
                                key={selectedPromptIdx}
                                placeholder="0"
                                type="number"
                                max={100}
                                min={0}
                                maxLength={3}
                                defaultValue={selectedPrompt.weight ?? 0}
                                onChange={(ev) => {
                                    debounce(() =>
                                        setVariant((update) => {
                                            update.weight = ev.target.value as any
                                            try {
                                                update.weight = parseInt(ev.target.value, 10)
                                            } catch (e) {}
                                            return update
                                        }),
                                    )
                                }}
                            />
                            <Space.Addon>
                                <span>%</span>
                            </Space.Addon>
                        </Space.Compact>
                    )}
                </Form.Item>
            </Flex>
        </Well>
    )
}
